module.exports = __webpack_public_path__ + "static/media/infografika_1-mi.cdc15cc3.png";